import uniqBy from 'lodash/uniqBy';

import { MAX_HOTEL_NIGHTS } from '~/types/bundles/bundle';

export interface HotelPackageOption {
  /** Salesforce package id, which svc-bundle and the flash calendar key packages by. */
  packageId: string;
  name: string;
  nightsOptions: Array<number>;
}

/** svc-offer returns a package per room rate; the bundle picks by Salesforce package. */
export function hotelPackageOptions(packages: Array<App.Package>): Array<HotelPackageOption> {
  return uniqBy(
    packages.filter((pkg) => !!pkg.id_salesforce_external),
    (pkg) => pkg.id_salesforce_external,
  ).map((pkg) => {
    const accommodation = pkg as App.AccommodationPackage;
    const minNights = Math.max(accommodation.number_of_nights ?? 1, 1);
    const maxNights = accommodation.flexible_nights ? minNights + (accommodation.max_extra_nights ?? 0) : minNights;
    const nightsOptions = Array.from({ length: maxNights - minNights + 1 }, (_, i) => minNights + i).filter(
      (nights) => nights <= MAX_HOTEL_NIGHTS,
    );
    return {
      packageId: pkg.id_salesforce_external,
      name: [accommodation.room_type?.name, pkg.name].filter(Boolean).join(' · '),
      nightsOptions,
    };
  });
}
